// WillingnessService.js
import axios from 'axios';

const API_BASE_URL = 'https://api.jamboricg.com/api/willingness';
const MAJANGA_API_BASE_URL = 'https://api.jamboricg.com/api/majanga';

// Intent Category API
export const WillingnessService = {
    // 1.1 Create Category
    createIntentCategory: async (data) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/intent-categories/`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 1.2 List Categories
    listIntentCategories: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/intent-categories/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 1.3 Update Category
    updateIntentCategory: async (id, data) => {
        try {
            const response = await axios.patch(`${API_BASE_URL}/intent-categories/${id}/`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 2.1 Create Onboarding Content
    createOnboardingContent: async (formData) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/onboarding-content/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 2.2 List Onboarding Content
    listOnboardingContent: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/onboarding-content/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 4.1 Create CEO Message
    createCeoMessage: async (data) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/ceo-messages/`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 4.2 List CEO Messages
    listCeoMessages: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/ceo-messages/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 4.3 Update CEO Message
    updateCeoMessage: async (id, data) => {
        try {
            const response = await axios.patch(`${API_BASE_URL}/ceo-messages/${id}/`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Delete operations for all entities
    deleteIntentCategory: async (id) => {
        try {
            await axios.delete(`${API_BASE_URL}/intent-categories/${id}/`);
            return { success: true };
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    deleteOnboardingContent: async (id) => {
        try {
            await axios.delete(`${API_BASE_URL}/onboarding-content/${id}/`);
            return { success: true };
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    deleteCeoMessage: async (id) => {
        try {
            await axios.delete(`${API_BASE_URL}/ceo-messages/${id}/`);
            return { success: true };
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Service Provider API Functions
    registerServiceProvider: async (formData) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/service-providers/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    listServiceProviders: async () => {
        try {
            const response = await axios.get(`${API_BASE_URL}/service-providers/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getServiceProvider: async (id) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/service-providers/${id}/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    updateServiceProvider: async (id, formData) => {
        try {
            const response = await axios.patch(`${API_BASE_URL}/service-providers/${id}/`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    deleteServiceProvider: async (id) => {
        try {
            await axios.delete(`${API_BASE_URL}/service-providers/${id}/`);
            return { success: true };
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Service API Functions
    createService: async (data) => {
        try {
            const response = await axios.post(`${API_BASE_URL}/services/`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getServices: async (serviceProviderId = null) => {
        console.log("services heated ------");
        try {
            const url = serviceProviderId
                ? `${API_BASE_URL}/services/?service_provider=${serviceProviderId}`
                : `${API_BASE_URL}/services/`;
            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    getService: async (id) => {
        try {
            const response = await axios.get(`${API_BASE_URL}/services/${id}/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    updateService: async (id, data) => {
        try {
            const response = await axios.patch(`${API_BASE_URL}/services/${id}/`, data);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    deleteService: async (id) => {
        try {
            await axios.delete(`${API_BASE_URL}/services/${id}/`);
            return { success: true };
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // ===== SERVICE REQUEST MANAGEMENT API FUNCTIONS =====

    // Fetch all service requests
    fetchServiceRequests: async (filters = {}) => {
        try {
            const params = new URLSearchParams();
            
            // Add filters to params if they exist
            Object.keys(filters).forEach(key => {
                if (filters[key] && filters[key] !== '') {
                    params.append(key, filters[key]);
                }
            });

            const queryString = params.toString();
            const url = queryString 
                ? `${MAJANGA_API_BASE_URL}/service-requests/all_requests_public/?${queryString}`
                : `${MAJANGA_API_BASE_URL}/service-requests/all_requests_public/`;
            
            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Fetch service request statistics
    fetchServiceRequestStatistics: async () => {
        try {
            const response = await axios.get(`${MAJANGA_API_BASE_URL}/service-requests/statistics_public/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get single service request details
    getServiceRequest: async (id) => {
        try {
            const response = await axios.get(`${MAJANGA_API_BASE_URL}/service-requests/${id}/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Update service request status (Enhanced)
    updateServiceRequestStatus: async (requestId, statusData) => {
        try {
            const { status, approved_amount, review_notes, reviewer_id } = statusData;
            
            // Validate required fields
            if (!status) {
                throw new Error('Status is required');
            }

            // Choose endpoint based on status type
            const isApprovalAction = ['approved', 'rejected'].includes(status);
            const endpoint = isApprovalAction 
                ? `${MAJANGA_API_BASE_URL}/service-requests/${requestId}/approve/`
                : `${MAJANGA_API_BASE_URL}/service-requests/${requestId}/update_status/`;

            // Prepare payload
            const payload = {
                status,
                review_notes: review_notes || '',
                ...(approved_amount !== null && approved_amount !== undefined && { approved_amount }),
                ...(reviewer_id && { reviewer_id })
            };

            // Additional validation for approval
            if (status === 'approved' && (approved_amount === null || approved_amount === undefined)) {
                throw new Error('Approved amount is required for approval');
            }

            const response = await axios.post(endpoint, payload, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Bulk update service requests
    bulkUpdateServiceRequests: async (requestIds, statusData) => {
        try {
            const response = await axios.post(`${MAJANGA_API_BASE_URL}/service-requests/bulk-update/`, {
                request_ids: requestIds,
                ...statusData
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Add priority to service request
    updateServiceRequestPriority: async (requestId, priority) => {
        try {
            const response = await axios.patch(`${MAJANGA_API_BASE_URL}/service-requests/${requestId}/priority/`, {
                priority
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Assign service request to reviewer
    assignServiceRequestReviewer: async (requestId, reviewerId) => {
        try {
            const response = await axios.post(`${MAJANGA_API_BASE_URL}/service-requests/${requestId}/assign/`, {
                reviewer_id: reviewerId
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Add comment/note to service request
    addServiceRequestComment: async (requestId, comment, isInternal = false) => {
        try {
            const response = await axios.post(`${MAJANGA_API_BASE_URL}/service-requests/${requestId}/comments/`, {
                comment,
                is_internal: isInternal
            });
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get service request history/audit trail
    getServiceRequestHistory: async (requestId) => {
        try {
            const response = await axios.get(`${MAJANGA_API_BASE_URL}/service-requests/${requestId}/history/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Export service requests
    exportServiceRequests: async (filters = {}, format = 'csv') => {
        try {
            const params = new URLSearchParams();
            
            Object.keys(filters).forEach(key => {
                if (filters[key] && filters[key] !== '') {
                    params.append(key, filters[key]);
                }
            });
            
            params.append('format', format);

            const response = await axios.get(`${MAJANGA_API_BASE_URL}/service-requests/export/?${params.toString()}`, {
                responseType: 'blob'
            });
            
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get service request analytics
    getServiceRequestAnalytics: async (dateRange = {}) => {
        try {
            const params = new URLSearchParams();
            
            if (dateRange.start_date) params.append('start_date', dateRange.start_date);
            if (dateRange.end_date) params.append('end_date', dateRange.end_date);

            const url = params.toString() 
                ? `${MAJANGA_API_BASE_URL}/service-requests/analytics/?${params.toString()}`
                : `${MAJANGA_API_BASE_URL}/service-requests/analytics/`;

            const response = await axios.get(url);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Get dashboard summary
    getDashboardSummary: async () => {
        try {
            const response = await axios.get(`${MAJANGA_API_BASE_URL}/service-requests/dashboard-summary/`);
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // Toggle priority status for a service provider
toggleServiceProviderPriority: async (id) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/service-providers/${id}/toggle_priority/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
},

// Rate a service provider
rateServiceProvider: async (id, ratingData) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/service-providers/${id}/rate/`, ratingData);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
},

// Get service provider with ratings
getServiceProviderWithRatings: async (id) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/service-providers/${id}/`);
        return response.data;
    } catch (error) {
        throw error.response?.data || error.message;
    }
},

// ══════════════════════════════════════════════════════════════════
    // APPROVAL CHAIN & ADMIN ACTIONS
    // ══════════════════════════════════════════════════════════════════
 
    // GET /service-requests/{id}/approval-chain/
    // Returns { approval_chain: [...steps], current_step, approval_chain_status, next_approver }
    fetchApprovalChain: async (serviceRequestId) => {
        try {
            const response = await axios.get(
                `${MAJANGA_API_BASE_URL}/service-requests/${serviceRequestId}/approval-chain/`
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },
 
    // GET /service-approvals/?service_request_id={id}
    // Returns { count, results: [...steps] }
    fetchApprovalSteps: async (serviceRequestId) => {
        try {
            const response = await axios.get(
                `${MAJANGA_API_BASE_URL}/service-approvals/?service_request_id=${serviceRequestId}`
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },
 
    // POST /service-requests/{id}/admin-final-approve/
    // payload: { decision: 'approved'|'rejected', notes: '', approved_amount: number }
    // Only use when approval_chain_status === 'pending_admin'
    adminFinalApprove: async (serviceRequestId, payload) => {
        try {
            const response = await axios.post(
                `${MAJANGA_API_BASE_URL}/service-requests/${serviceRequestId}/admin-final-approve/`,
                payload,
                { headers: { 'Content-Type': 'application/json' } }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },
 
    // POST /service-requests/{id}/submit-for-approval/
    // Manually starts the chain — fallback if auto-start fails
    submitForApproval: async (serviceRequestId) => {
        try {
            const response = await axios.post(
                `${MAJANGA_API_BASE_URL}/service-requests/${serviceRequestId}/submit-for-approval/`,
                {},
                { headers: { 'Content-Type': 'application/json' } }
            );
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },
 
    // DELETE /service-requests/{id}/
    deleteServiceRequest: async (serviceRequestId) => {
        try {
            await axios.delete(
                `${MAJANGA_API_BASE_URL}/service-requests/${serviceRequestId}/`
            );
            return { success: true };
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },
};

export default WillingnessService;